module.exports = __webpack_public_path__ + "static/media/ico_btn_paroles.6368f555.svg";